var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'pass-pay-root': _vm.isPassPay, 'poster-root': _vm.isPoster, 'verify-root': _vm.isVerify },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }